import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Modal from 'components/Modal';
import actions from 'state/actions';
import selectors from 'state/selectors';
import services from 'services';
import utils from 'utils';
import { KpiCategoryFilterValue } from 'models/request';

export interface DrillDownFilters {
  dateFrom: string;
  dateTo: string;
  idCompanyList?: number[];
  idDocTypeList?: number[];
  idGbsList?: number[];
  idGeoList?: any;
  incChannelList?: number[];
  idMetric: number;
  kpiCategoryFilterValues?: KpiCategoryFilterValue[];
}
const DrillDownKpiModal = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const t = utils.intl.useTranslator();
  const { filters }: { filters: DrillDownFilters } = useSelector(selectors.modal.getModalProps);

  const handleDrillDown = async () => {
    try {
      const serviceFilters = {
        dateFrom: filters.dateFrom,
        dateTo: filters.dateTo,
        idCompanyList: filters.idCompanyList,
        idDocTypeList: filters.idDocTypeList,
        idGbsList: filters.idGbsList,
        idGeoList: filters.idGeoList,
        incChannelList: filters.incChannelList,
        idMetric: filters.idMetric,
        kpiCategoryFilterValues: filters.kpiCategoryFilterValues,
      };

      const { data } = await services.getDrillDownKpiData(serviceFilters);

      history.push({
        pathname: '/invoice-management',
        state: {
          drillDownData: data,
        },
      });
      dispatch(actions.modal.closeModal());
    } catch (error) {
      console.error(error);
      utils.app.notify('fail', t('drill-down-kpi-error'));
      dispatch(actions.modal.closeModal());
    }
  };

  return (
    <>
      <Modal.Header title={t('drill-down-kpi-title')} subtitle={t('drill-down-kpi-subtitle')} />
      <Modal.Footer confirmAction={handleDrillDown} confirmText={t('drill-down')} closeButtonText={t('cancel')} />
    </>
  );
};

export default DrillDownKpiModal;
